import { observable, action } from 'mobx';
import { Api } from 'services/Api';
import stores from './index';

class FormStore {
  @observable forms = {
    isLoading: false,
    isError: false,
    objects: [],
    meta: {}
  };

  @observable isSavingForm = false;

  @observable form = {
    isLoading: false,
    isError: false,
    object: {}
  };

  @action
  // `attributes` come from the Add Form dialog, which keeps its own fields so
  // it never re-sends the form last opened in the builder (form.object).
  createForm(attributes) {
    this.form.isLoading = true
    let promise = Api.post(`/forms`, {form: attributes})

    promise
      .then((response) => {
        this.form.isLoading = false;
        this.form.isError = false;
        this.form.object = response.data.data
        stores.viewStore.formShow({uuid: this.form.object.attributes.id})
      })
      .catch((error) => {
        this.form.isLoading = false;
        this.form.isError = true;
      })
    
    return promise;
  }

  @action
  deleteForm(form) {
    this.form.isLoading = true
    let promise = Api.delete(`/forms/${form.id}`)

    promise
      .then((response) => {
        this.form.isLoading = false;
        this.form.isError = false;
        this.loadForms()
      })
      .catch((error) => {
        this.form.isLoading = false;
        this.form.isError = true;
      })
    
    return promise;
  }

  @action
  loadForms = () => {
    this.forms.isLoading = true;
    const {
      per_page,
      page,
      order,
      term
    } = stores.viewStore.formSearch;
    let promise = Api.post('/forms/search', {
      search: {
        term: term,
        per_page: per_page,
        page: page,
        order: order
      }
    });

    promise
      .then((response) => {
        this.forms.isLoading = false;
        this.forms.isError = false;
        this.forms.objects = response.data.data;
        this.forms.meta = response.data.meta;
      })
      .catch((error) => {
        this.forms.isLoading = false;
        this.forms.isError = true;
        console.error(error)
      })
    
    return promise;
  }

  @action
  clearSelectedForm() {
    this.form = {
      isLoading: false,
      isError: false,
      object: null
    }
  }

  @action
  loadForm(params) {
    this.form.isLoading = true;
    let promise = Api.get(`/forms/${params.uuid}`)
    
    promise
      .then((response) => {
        this.form.isLoading = false;
        this.form.isError = false;
        this.form.object = response.data.data
      })
      .catch((error) => {
        this.form.isLoading = false;
        this.form.isError = true;
        console.error(error)
      })

    return promise;
  }

  @action
  // Saves the form builder's questions. Its own flag, so the builder stays on
  // screen while saving (and after a failure, which the page reports).
  updateForm(params) {
    this.isSavingForm = true;
    let promise = Api.put(`/forms/${params.uuid}`, params)

    promise
      .then((response) => {
        this.isSavingForm = false;
        this.form.object = response.data.data;
      })
      .catch(() => {
        this.isSavingForm = false;
      })

    return promise;
  }

};

export default FormStore;